<template>
  <div>
    <v-row>
      <v-col
        v-for="(item, i) in tabs"
        :key="i"
        cols="auto"
      >
        <v-btn
          :text="item.id != tab"
          @click="tab = item.id"
        >
          {{ item.name }}
        </v-btn>
      </v-col>
    </v-row>

    <v-card
      outlined
      class="mt-4"
    >
      <UserOrders v-if="tab == 'orders'" />
      <UserProjects v-if="tab == 'projects'" />
      <UserPayouts v-if="tab == 'payouts'" />
    </v-card>
  </div>
</template>

<script>
import UserOrders from '@/components/users/detail/lists/Orders';
import UserProjects from '@/components/users/detail/lists/Projects';
import UserPayouts from '@/components/users/detail/lists/Payouts';
import { mapGetters } from 'vuex';
export default {
  name: 'UserLists',
  components: { UserOrders, UserProjects, UserPayouts },
  data() {
    return {
      tab: 'orders'
    };
  },
  computed: {
    tabs() {
      const list = [
        { id: 'orders', name: 'Orders' },
        { id: 'projects', name: 'Projects' }
      ];

      if (this.user.isContributor) {
        list.push({ id: 'payouts', name: 'Payouts' });
      }

      return list;
    },
    ...mapGetters({ user: 'users/user' })
  },
  methods: {}
};
</script>
